import React from 'react';
import _ from 'lodash';

import LiveSubpage from "../../pages/LiveSubpage";

class TaskEditorIterateAdminPage extends LiveSubpage {
  constructor(props) {
    super(props);
    this.iframeRef = React.createRef();
    this.state = {
      ...this.state,
      iframeUrl: props.task.input.url + '&collapsed=true',
    };
  }
  componentDidMount() {
    super.componentDidMount();
    console.log('loading task page', this.props.task)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.task.input.url !== this.props.task.input.url) {
      if (this.iframeRef.current) {
        const newUrl = this.props.task.input.url;
        try {
          this.iframeRef.current.contentWindow.postMessage({ type: "NAVIGATE", path: newUrl + '&collapsed=true' }, window.location.origin);          
        } catch (e) {
          console.error("Error comparing iframe URLs, falling back to reload", e);
          this.setState({ iframeUrl: newUrl });
        }
      }
    }
  }

  renderExtractionControls() {
    // This method must be overriden by Subclasses
    return <div className={'p-2 pt-4 text-center'}>
      {
        <span className={'btn btn-success'} onClick={() => this.props.batchEditor.doneAndNext()}>
          DONE AND NEXT
        </span>
      }
    </div>
  }

  renderPageBody() {
    let { task, ... props } = this.props;

    let [context] = task.context || [];
    let comment = task.input?.comment;

    return <React.Fragment>
      <div className={'grid-pdf-extraction grid-pdf-extraction--min-bar'}>
        <iframe ref={this.iframeRef} src={this.state.iframeUrl} width="100%" height="100%" key="do-not-change" />

        <div className={'bg-light'} id={'extractionInputArea'} key={task?._id}>
          { comment ? <div className={'alert alert-info small mb-0 rounded-0'} style={{ whiteSpace: 'pre-wrap' }}>{comment}</div> : null }

          { this.renderExtractionControls() }

          <div className={'border border-left-0 border-right-0'}>
            { this.props.batchEditor.getTaskStateControls()}
          </div>
        </div>
      </div>
    </React.Fragment>;
  }
}

export default function TaskEditorIterateAdminPageLiveReload(props) {
  return <TaskEditorIterateAdminPage {...props} />
}